module.exports = __webpack_public_path__ + "static/img/blog_onboarding.4bb6e874.png";